import {Storage} from "@/services/Storage";
import axios from "axios";

export default {
    name: 'tax',

    state: {
        hasDocsSubmitted: false,
        isSmartInvoiceLive: true,
        taxLabels : [],
    },
    getters: {
        getDocSubmissionStatus: (state) => state.hasDocsSubmitted,
        getSmartInvoicingLive: (state) => state.isSmartInvoiceLive,
        getTaxLabels : (state) => state.taxLabels,
        getZraCategoryByLabel : (state) => (taxLabel) => {
            return state.taxLabels.find(category => category.TaxLabel.toLowerCase() === taxLabel.toLowerCase());
        }
    },
    mutations: {
        setDocSubmissionStatus: (state, data) => state.hasDocsSubmitted = data,
        setTaxLabels : async (state , payload) => {
            if (!payload) payload = await Storage.getAllTaxLabels();
            state.taxLabels = payload;
        }
    },
    actions: {
        checkIfStoreDocsSubmitted: async (context) => {
            let DB = await Storage.getCurrentStoreDB();
            DB = window.btoa(DB);
            return axios.get(ticketApi + `smartInvoiceOnboard/checkDocumentSubmissionStatus`, {
                headers: {DB}
            }).then(({data}) => context.commit(`setDocSubmissionStatus`, data))

        },
        getAllTaxLabels : async (context) => {
            let store = await Storage.getDefaultStore();
            if (!store) return ;
            return axios.get(backOfficeTomcatApi+`zra_category/${store.StoreDB}/getAll`)
                .then(({data}) => context.commit(`setTaxLabels`, data))
                .catch(err=>errorHandler.tomcatError(err))
        },
        /**
         * Verify a Zambia ZRA TPIN via Franchise Online AndroidLogin endpoint.
         * Copied from Lytning Core tax-module.js — FE-only pattern; do not invent alternate validation.
         * @param {*} context Vuex context (unused)
         * @param {string} tpin TPIN digits to look up
         * @returns {Promise<object>} ZRA taxpayer payload when data.tpin is present
         */
        checkZRADetails: async (context, tpin) => {
            // Lytning Core pattern: GET franchiseTomcatApi + AndroidLogin/TPIN/{tpin}
            return axios.get(franchiseTomcatApi + `AndroidLogin/TPIN/${tpin}`)
                .then(({data}) => {
                    if (data.tpin) {
                        return data;
                    } else if (data.toString().includes(`Send TPIN:`)) {
                        throw new Error(`Invalid TPIN`);
                    }
                }).catch(err => errorHandler.tomcatError(err))
        },
    }
}
